import React, { useEffect, useState } from "react";
import { Rocket, TrendingUp, Heart, Users, Star, Lightbulb, DollarSign, Play } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, StatCard, Spinner } from "@/components/Bits";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function CreatorHub() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/creator/analytics").then((r) => setA(r.data)); }, []);
  if (!a) return <Spinner />;

  return (
    <div className="p-5 lg:p-8 max-w-6xl mx-auto">
      <PageHeader title="Creator Hub" icon={Rocket} subtitle="Your analytics, audience and growth insights." />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        <StatCard label="Total plays" value={a.total_plays} icon={Play} delay={1} />
        <StatCard label="Total likes" value={a.total_likes} icon={Heart} accent="#ef4444" delay={2} />
        <StatCard label="Followers" value={a.followers} icon={Users} accent="#10b981" delay={3} />
        <StatCard label="Avg rating" value={a.avg_rating || "—"} icon={Star} accent="#f59e0b" delay={4} />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-5">
          <div className="font-display font-bold mb-4 flex items-center gap-2"><TrendingUp className="w-5 h-5 text-[hsl(var(--primary))]" /> Top games</div>
          {a.top_games.length === 0 ? <p className="text-sm text-[hsl(var(--muted-foreground))]">Publish games to see performance here.</p> : (
            <div className="space-y-3">
              {a.top_games.map((g, i) => (
                <div key={g.id} className="flex items-center gap-3">
                  <span className="w-6 font-bold text-[hsl(var(--muted-foreground))]">{i + 1}</span>
                  <span className="text-2xl">{g.cover_emoji}</span>
                  <span className="flex-1 font-semibold truncate">{g.title}</span>
                  <span className="text-sm text-[hsl(var(--muted-foreground))] flex items-center gap-1"><Play className="w-3.5 h-3.5" /> {g.plays}</span>
                  <span className="text-sm text-[hsl(var(--muted-foreground))] flex items-center gap-1"><Heart className="w-3.5 h-3.5" /> {g.likes}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="space-y-4">
          <div className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-5">
            <div className="font-display font-bold mb-3 flex items-center gap-2"><Lightbulb className="w-5 h-5 text-amber-500" /> Studio insights</div>
            <ul className="space-y-2 text-sm">
              {a.insights.map((ins, i) => <li key={i} className="flex gap-2"><span className="text-[hsl(var(--primary))]">→</span> {ins}</li>)}
            </ul>
          </div>
          <div className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-5">
            <div className="font-display font-bold mb-1 flex items-center gap-2"><DollarSign className="w-5 h-5 text-emerald-500" /> Monetisation</div>
            <div className="text-3xl font-display font-extrabold">${a.revenue_placeholder.toFixed(2)}</div>
            <p className="text-xs text-[hsl(var(--muted-foreground))] mb-3">Lifetime earnings</p>
            <Button variant="outline" size="sm" className="rounded-full w-full" onClick={() => toast.info("Stripe Connect onboarding launches in Phase 2.")} data-testid="stripe-connect-btn">Set up payouts (Stripe Connect)</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
